import "../../style.css";
import "../user-area.css";
import "./preference.css";
import FormControlLabel from "@mui/material/FormControlLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Switch from "@mui/material/Switch";
import React, { useEffect, useState } from "react";
import { API_URL } from "../../../api";
import Banner from "../../../components/banner/Banner";
import verificationStatus from "../Profil/Profil";

let debounceTimeout;
let buttonTimeout;

const Preference = ({ data }) => {
	const initialSwitchValue = {
		sendvic: Boolean(data.sendvic),
		napitek: Boolean(data.napitek),
		majoneza: Boolean(data.majoneza),
		hrenovka: Boolean(data.hrenovka),
	};

	const [SwitchStatus, setSwitchStatus] = useState(initialSwitchValue);
	const [newMessage, setNewMessage] = useState("");
	const [changeBanner, setChangeBanner] = useState(false);
	const [buttonDisabled, setButtonDisabled] = useState(false);
	const [autoOrder, setAutoOrder] = useState(Boolean(data.autoOrder));
	const [AutoOrderButtonState, setAutoOrderButtonState] = useState(
		data.autoOrder ? "btn-active" : "btn-disabled"
	);
	const [pouk, setPouk] = useState(() => {
		if (data.pouk) {
			return data.pouk;
		} else {
			return 0;
		}
	});

	const handleChange = (event) => {
		clearTimeout(debounceTimeout);

		setSwitchStatus((prevValues) => {
			const newValues = { ...prevValues };
			newValues[event.target.name] = !prevValues[event.target.name];
			return newValues;
		});

		debounceTimeout = setTimeout(() => {
			if (event.target.name === "napitek") {
				fetch(
					`${API_URL}/api/menu_data_modification?token=${encodeURIComponent(
						data.sessionToken
					)}&menu_data=${encodeURIComponent(
						event.target.checked
					)}&type=napitek`
				)
					.then((response) => {
						console.log(response.ok);
					})
					.catch((error) => {
						console.log(error);
					});
			} else if (event.target.name === "sendvic") {
				fetch(
					`${API_URL}/api/menu_data_modification?token=${encodeURIComponent(
						data.sessionToken
					)}&menu_data=${encodeURIComponent(
						event.target.checked
					)}&type=sendvic`
				)
					.then((response) => response.json())
					.catch((error) => {
						console.log(error);
					});
			} else if (event.target.name === "pouk") {
				fetch(
					`${API_URL}/api/menu_data_modification?token=${encodeURIComponent(
						data.sessionToken
					)}&menu_data=${encodeURIComponent(
						event.target.value
					)}&type=pouk`
				)
					.then((response) => response.json())
					.then((result) => {
						setPouk(event.target.value);
					})
					.catch((error) => {
						console.log(error);
					});
			} else if (event.target.name === "majoneza") {
				fetch(
					`${API_URL}/api/menu_data_modification?token=${encodeURIComponent(
						data.sessionToken
					)}&menu_data=${encodeURIComponent(
						event.target.checked
					)}&type=majoneza`
				)
					.then((response) => response.json())
					.catch((error) => {
						console.log(error);
					});
			} else if (event.target.name === "hrenovka") {
				fetch(
					`${API_URL}/api/menu_data_modification?token=${encodeURIComponent(
						data.sessionToken
					)}&menu_data=${encodeURIComponent(
						event.target.checked
					)}&type=hrenovka`
				)
					.then((response) => response.json())
					.catch((error) => {
						console.log(error);
					});
			}
		}, 300);
	};

	useEffect(() => {
		return () => {
			clearTimeout(debounceTimeout);
		};
	}, []);

	const handleClick = () => {
		setButtonDisabled(true);

		fetch(
			`${API_URL}/api/menu_data_modification?token=${encodeURIComponent(
				data.sessionToken
			)}&menu_data=${encodeURIComponent(!autoOrder)}&type=autoOrder`
		)
			.then((response) => response.json())
			.then((result) => {
				if (result.autoOrder !== "email") {
					if (result.autoOrder === true) {
						setNewMessage("Naročanje malice je zdaj avtomatsko.");
						setChangeBanner(true);
						setAutoOrderButtonState("btn-active");
						setAutoOrder(true);

						console.log(result);
					} else if (result.autoOrder === false) {
						setNewMessage("Naročanje malice je zdaj ročno.");
						setChangeBanner(true);
						setAutoOrderButtonState("btn-disabled");
						setAutoOrder(false);
					} else {
						setNewMessage("Napaka pri posodabljanju.");
						setChangeBanner(true);
					}
				} else {
					setNewMessage("Najprej moraš potrditi svoj email.");
					setAutoOrder(false);
					setAutoOrderButtonState("btn-disabled");
					setChangeBanner(true);
				}
			})
			.catch((error) => {
				console.log(error);
				setNewMessage("Napaka pri posodabljanju.");
				setChangeBanner(true);
			});
		buttonTimeout = setTimeout(() => {
			setButtonDisabled(false);
		}, 5000);
	};
	useEffect(() => {
		if (changeBanner === true) {
			setTimeout(() => {
				setChangeBanner(false);
				setNewMessage("");
			}, 4000);
		}
	}, [changeBanner]);

	return (
		<div className="preference">
			{changeBanner ? (
				<Banner message={newMessage} banner={true} />
			) : (
				<div></div>
			)}
			{verificationStatus ? (
				""
			) : (
				<h3>
					⬆️ Za potrditev emaila kliknite na ikono v desnem kotu
					zgoraj.
				</h3>
			)}
			<h2>Nastavitve</h2>
			<p>Izberi katero od navedenih stvari imaš raje.</p>
			<p>
				Če boš npr. izbral sendvič ti bo program pogosteje izbral
				sendvič kot ostale (tople ali mrzle) jedi.
			</p>
			<div className="choices">
				<div className="choice">
					<p>Ostale jedi</p>
					<FormControlLabel
						control={
							<Switch
								checked={SwitchStatus.sendvic}
								onChange={handleChange}
								name="sendvic"
								sx={{
									"& .MuiSwitch-track": {
										bgcolor: "cyan",
									},
								}}
								color="default"
							/>
						}
						title="Izberi ali želiš, da ima sendvič prednost pred toplimi obroki"
					/>
					<p>Sendvič</p>
				</div>
				<div className="choice">
					<p>Brez majoneze</p>
					<FormControlLabel
						control={
							<Switch
								checked={SwitchStatus.majoneza}
								onChange={handleChange}
								name="majoneza"
								sx={{
									"& .MuiSwitch-track": {
										bgcolor: "cyan",
									},
								}}
								color="default"
							/>
						}
						title="Izberi ali imaš rad majonezo ali ne."
					/>
					<p>Majoneza</p>
				</div>
				<div className="choice">
					<p>Brez hrenovka</p>
					<FormControlLabel
						control={
							<Switch
								checked={SwitchStatus.hrenovka}
								onChange={handleChange}
								name="hrenovka"
								sx={{
									"& .MuiSwitch-track": {
										bgcolor: "cyan",
									},
								}}
								color="default"
							/>
						}
						title="Izberi ali imaš rad hrenovko ali ne."
					/>
					<p>Hrenovka je OK</p>
				</div>
				<div className="choice">
					<p>Nikoli pire krompirja</p>
					<FormControlLabel
						control={
							<Switch
								checked={SwitchStatus.napitek}
								onChange={handleChange}
								name="napitek"
								sx={{
									"& .MuiSwitch-track": {
										bgcolor: "cyan",
									},
								}}
								color="default"
							/>
						}
						title="Izberi ali želiš, da ima napitek prednost pred vodo."
					/>
					<p>Pire krompir je OK</p>
				</div>
			</div>
			<div className="pouk">
				<p>Pouk popoldne?</p>
				<Select
					value={pouk}
					label="pouk"
					name="pouk"
					onChange={handleChange}
					style={{
						color: "white",
						border: "1px solid white",
						margin: "0 20px",
					}}>
					<MenuItem value={0}>Nikoli</MenuItem>
					<MenuItem value={1}>Ponedeljek</MenuItem>
					<MenuItem value={2}>Torek</MenuItem>
					<MenuItem value={3}>Sreda</MenuItem>
					<MenuItem value={4}>Četrtek</MenuItem>
					<MenuItem value={5}>Petek</MenuItem>
				</Select>
			</div>
			<div className="auto-order">
				<h3>Avtomatsko naročanje malice:</h3>
				<button
					onClick={handleClick}
					className={`btn ${AutoOrderButtonState}`}
					disabled={buttonDisabled}>
					{autoOrder ? "Vključeno" : "Izključeno"}
				</button>
			</div>
			<button
				onClick={() => {
					window.location.reload();
				}}
				className="btn prefer-save">
				Shrani
			</button>
		</div>
	);
};
export default Preference;
